import { useState } from 'react'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Grid from '@mui/material/Grid'
import CloseIcon from '@mui/icons-material/Close'
import { InfoModal } from 'components/common/Modal'
import LinkItem from './LinkItem'
import { getSinyiSiteResources } from 'utils/api'

const defaultSinyiResources = [
  {
    subtitle: '信義房屋粉絲團',
    url: 'https://www.facebook.com/sinyifans/',
  },
  {
    subtitle: '信義房屋YouTube',
    url: 'https://www.youtube.com/channel/UCU76s7FGtDvDta2mf2Zdn4Q',
  },
  {
    subtitle: '信義房屋Android APP',
    url:
      'https://play.google.com/store/apps/details?id=com.thinkermobile.sinyi&hl=zh_TW',
  },
  {
    subtitle: '信義房屋Ios APP',
    url:
      'https://apps.apple.com/tw/app/%E4%BF%A1%E7%BE%A9%E6%88%BF%E5%B1%8B-%E9%97%9C%E6%96%BC%E5%AE%B6-%E6%89%BE%E4%BF%A1%E7%BE%A9%E8%81%8A%E8%81%8A/id362879359',
  },
  {
    subtitle: '信義房屋Wiki',
    url: 'https://zh.wikipedia.org/zh-tw/%E4%BF%A1%E7%BE%A9%E6%88%BF%E5%B1%8B',
  },
  {
    subtitle: '信義房屋房市新聞',
    url: 'https://www.sinyinews.com.tw/',
  },
]

const SinyiResources = () => {
  const [sinyiResources, setSinyiResources] = useState(defaultSinyiResources)
  const [modal, setModal] = useState({ open: false })
  const isLgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'))

  const openSinyiResourceModal = async () => {
    const [resources, error] = await getSinyiSiteResources()
    if (!error) {
      const links = resources?.brands
        ?.map((brand) => brand.content)
        ?.reduce((results, content) => results.concat(content), [])

      // 由於網站資源連結不是由我們維護，故在以下添加要新增的項目
      // 添加信義開發連結
      if (links && Array.isArray(links)) {
        links.push({
          subtitle: '信義開發',
          url: 'https://www.xinyikf.com.tw/',
        })
      }

      setSinyiResources(links)
    }
    setModal({ open: true })
  }

  return (
    <Box>
      {!isLgUp ? (
        <Box display="flex">
          <Box
            component="span"
            mx={3}
            height="17px"
            width="1px"
            backgroundColor="#D4D4D4"
          />
          <LinkItem
            $isFirst={isLgUp ? false : true}
            onClick={openSinyiResourceModal}
            style={{ cursor: 'pointer' }}
          >
            信義資源網站
          </LinkItem>
        </Box>
      ) : (
        <LinkItem
          $isFirst={isLgUp ? false : true}
          onClick={openSinyiResourceModal}
          style={{ cursor: 'pointer' }}
        >
          信義資源網站
        </LinkItem>
      )}

      <InfoModal open={modal.open} onClose={() => setModal({ open: false })}>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} pl={5}>
            <Typography variant="subtitle2">信義資源網站</Typography>
          </Box>
          <Box py={2} pr={2}>
            <IconButton onClick={() => setModal({ open: false })} size="large">
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Box p={5} pt={1} pb={10}>
          <Grid container>
            {sinyiResources?.map((resource, index) => (
              <Grid item xs={6} key={index}>
                <LinkItem href={resource.url} target="_blank">
                  {resource.subtitle}
                </LinkItem>
              </Grid>
            ))}
          </Grid>
        </Box>
      </InfoModal>
    </Box>
  )
}

export default SinyiResources
